<template>
    <div>
        <!-- Button -->
        <v-btn-ternary :disabled="!isEnable" @click="run()" class="ml-2">
            Relance l'analyse
        </v-btn-ternary>
        <!-- SnackBar to display message -->
        <v-snackbar color="primary" v-model="isSnackBarVisible">
            <p v-html="resultMessage"></p>
            <template v-slot:actions>
                <v-btn variant="text" color="indigo" @click="hideSnackBar()"> Fermer </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, toNative } from "vue-facing-decorator";
import ANALYSE_DOCUMENT from "../../graphql/document/AnalyseDocument.gql";

@Component
export class DocumentMultipleAnalysis extends Vue {
    @Prop({ default: false }) isEnable: boolean;
    @Prop({ default: [] }) documents: { id: string; displayName: string }[];

    isSnackBarVisible = false;
    resultMessage = ``;

    runOkMessage = `Analyse des documents lancée avec succès`;
    runKoMessage = `Echec du lancement de l'anaylse de documents`;

    async run() {
        let promises = [];
        for (const document of this.documents) {
            const mutationOption = {
                mutation: ANALYSE_DOCUMENT,
                variables: {
                    id: document.id,
                },
            };
            promises.push(this.$apollo.mutate(mutationOption));
        }

        try {
            await Promise.all(promises);
            this.resultMessage = this.runOkMessage;
        } catch (error) {
            console.log(error);
            this.resultMessage = this.runKoMessage;
        } finally {
            this.isSnackBarVisible = true;
        }
    }

    hideSnackBar() {
        this.isSnackBarVisible = false;
    }
}

export default toNative(DocumentMultipleAnalysis);
</script>
